export const gtLayer = () => {
  const handleMenuDataLayerClickResource = (
    menuLevel: number,
    parent: string,
    label: string,
    raqNumber: number,
    ctaLink: string
  ) => {
    const data = {
      event: "main_navigation_interaction",
      "menu-level": menuLevel,
      "menu-parent": parent,
      "menu-item": label,
      "menu-item-raq": raqNumber,
      "page-path": ctaLink,
    };
    window.dataLayer?.push(data);
  };

  const mainCtaMenuDataLayer = (ctaLabel: string) => {
    const data = {
      event: "cta_button_interaction",
      cta: ctaLabel,
      "page-path": window.location.pathname,
    };
    window.dataLayer?.push(data);
  };

  const ctaDataLayer = (ctaLabel: string, location: string) => {
    const data = {
      event: "cta_button_interaction",
      cta: ctaLabel,
      location: location,
      "page-path": window.location.pathname,
    };
    window.dataLayer?.push(data);
  };

  const emailCapturingDataLayer = (email: string) => {
    const data = {
      event: "email_captured",
      email: email,
      pagePath: window.location.pathname,
    };
    window.dataLayer?.push(data);
  };

  return { handleMenuDataLayerClickResource, mainCtaMenuDataLayer, ctaDataLayer, emailCapturingDataLayer };
};
